import { FETCH_COMMENTS, ADD_COMMENT_REPLY, EDIT_COMMENT_REPLY } from "../constants/comments";
import { Action, CommentState } from "../models/comments";
import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../utils";

const initialState: CommentState = {
  isFetching: false,
  count: null,
  currentPage: null,
  pageCount: null,
  data: [],
  error: null,
};

function data(state: CommentState = initialState, action: Action): CommentState {
  switch (action.type) {
    case getSuccessActionType(FETCH_COMMENTS):
      return { ...state, isFetching: false, ...action.payload };

    case getFailureActionType(FETCH_COMMENTS):
    case getFailureActionType(EDIT_COMMENT_REPLY):
    case getFailureActionType(ADD_COMMENT_REPLY):
      return { ...state, error: action.payload, isFetching: false };

    case getRequestActionType(FETCH_COMMENTS):
    case getRequestActionType(EDIT_COMMENT_REPLY):
    case getRequestActionType(ADD_COMMENT_REPLY):
      return { ...state, isFetching: true };

    case getSuccessActionType(EDIT_COMMENT_REPLY): {
      const { replyId } = action.data;
      const indexU = state.data.findIndex((i) => i.reply[0]?.id === replyId);
      const updatedReply = action.payload;
      state.data[indexU].reply[0] = updatedReply;

      return {
        ...state,
        isFetching: false,
        data: state.data,
      };
    }

    case getSuccessActionType(ADD_COMMENT_REPLY): {
      const indexU = state.data.findIndex((i) => i.id == action.payload.parent);
      const addedReply = { id: action.payload.id, body: action.payload.body, doctorId: action.payload.modelId };
      state.data[indexU].reply.push(addedReply);
      state.data[indexU].reply_count = 1;

      return {
        ...state,
        isFetching: false,
        data: state.data,

        // data: [...state.data.slice(0, indexU), updatedReply, ...state.data.slice(indexU + 1)],
      };
    }
    default:
      return state;
  }
}

export default data;
